import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  {
    key: 'rawText',
    label: 'Raw Import Text',
    required: true,
    helperText: 'Exact business text as it appears in the source file (matched case-insensitively).',
  },
  {
    key: 'businessId',
    label: 'Business',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/businesses/list',
    displayKey: 'businessName',
  },
];

// Admin view of BusinessAlias — same purpose as ProductAliasManagement, for
// the Business field instead of Product.
const BusinessAliasManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Business Map"
    icon={<LinkIcon />}
    apiPath="/api/business-aliases"
    fields={fields}
    entityLabel="Business Alias"
    softDelete={false}
  />
);

export default BusinessAliasManagement;
